import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export interface ImageStylesProps {
  width: number;
  height: number;
  top?: number;
  left?: number;
  right?: number;
  borderRadius?: string;
  zIndex?: number;
  flip?: boolean;
  show?: boolean;
  rotate?: number;
  showBoxShadow?: boolean;
}

export const Wrapper = styled(Flex)`
  height: 540px;
  position: relative;
  ${themeMediaQuery('below_sm')} {
    height: 225px;
  }
`;

export const ImagesWrapper = styled(Flex)`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
`;

export const PlayIconTextWrapper = styled(ImagesWrapper)`
  z-index: 4;
  top: 46%;
  width: max-content;
  gap: ${themeSpace(3)};
  &:hover {
    cursor: pointer;
  }
  ${themeMediaQuery('below_sm')} {
    top: 42%;
  }
`;

export const VideoWrapper = styled(ImagesWrapper)`
  width: 762px;
  height: 540px;
  margin-left: auto;
  margin-right: auto;
  z-index: 3;
  background: ${themeColor('mono2')};
  ${themeMediaQuery('below_sm')} {
    width: 318px;
    height: 225px;
  }
`;

export const VideoOverlay = styled(Flex)`
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0.32));
`;

export const StyledCloudImage = styled(CloudImage)<{ mobile: ImageStylesProps; sm: ImageStylesProps }>`
  position: absolute;
  ${themeMediaQuery('below_sm')} {
    ${props => {
      return {
        width: `${props.mobile.width}px`,
        height: `${props.mobile.height}px`,
        top: props.mobile.top ?? '',
        left: props.mobile.left ?? '',
        right: props.mobile.right ?? '',
        zIndex: props.mobile.zIndex ?? '',
        borderRadius: props.mobile.borderRadius ?? '4px',
        visibility: props.mobile.show ? 'visible' : 'hidden',
        transform: `rotate(${props.mobile.rotate ?? 0}deg)  ${props.mobile.flip ? 'scaleX(-1)' : ''}`,
        boxShadow: props.mobile.showBoxShadow ? '0px 7px 27px rgba(44, 41, 37, 0.06), 0px 4px 16px rgba(0, 0, 0, 0.07)' : 'none',
      };
    }}
  }
  ${themeMediaQuery('sm')} {
    ${props => {
      return {
        width: `${props.sm.width}px`,
        height: `${props.sm.height}px`,
        top: props.sm.top ?? '',
        left: props.sm.left ?? '',
        right: props.sm.right ?? '',
        zIndex: props.sm.zIndex ?? '',
        borderRadius: props.sm.borderRadius ?? '4px',
        visibility: props.sm.show ? 'visible' : 'hidden',
        transform: `rotate(${props.sm.rotate ?? 0}deg)  ${props.sm.flip ? 'scaleX(-1)' : ''}`,
        boxShadow: props.sm.showBoxShadow ? '0px 7px 27px rgba(44, 41, 37, 0.06), 0px 4px 16px rgba(0, 0, 0, 0.07)' : 'none',
      };
    }}
  }
`;

export const TitleWrapper = styled(ImagesWrapper)`
  z-index: 4;
  width: 32vw;
  position: absolute;
  bottom: 64px;
  text-align: center;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
  ${themeMediaQuery('md')} {
    width: 19vw;
  }
  ${themeMediaQuery('lg')} {
    width: 16vw;
  }
`;

export const DisplayAboveMobile = styled(Flex)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const DisplayOnMobile = styled(Flex)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;
